import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { NgbDateAdapter, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import {
    FormFunctions,
    CustomDateAdapter,
    CustomDateParserFormatter

} from '../functions';

import {
    AuctionsLayoutComponent
} from './layouts';

import {
    WebsilkDateField,
    WebsilkLoading,
    WebsilkSelectField,
    WebsilkTextField,
    WebsilkLoginComponent,
    AddressAutoCompleteComponent,
    PageBannerComponent
} from './components';

import {
    ModalResetPasswordComponent
} from './modals';

import {
    InDollarsPipe,
    WithLoadingPipe,
} from '../pipes';

@NgModule({
    imports: [
        RouterModule,
        CommonModule,
        FormsModule,
        NgSelectModule,
        NgbModule,
        GooglePlaceModule
    ],
    declarations: [
        AuctionsLayoutComponent,
        WebsilkDateField,
        WebsilkLoading,
        WebsilkSelectField,
        WebsilkTextField,
        WebsilkLoginComponent,
        AddressAutoCompleteComponent,
        ModalResetPasswordComponent,
        InDollarsPipe,
        WithLoadingPipe,
        PageBannerComponent
    ],
    exports: [
        AuctionsLayoutComponent,
        WebsilkDateField,
        WebsilkLoading,
        WebsilkSelectField,
        WebsilkTextField,
        WebsilkLoginComponent,
        AddressAutoCompleteComponent,
        ModalResetPasswordComponent,
        InDollarsPipe,
        WithLoadingPipe,
        PageBannerComponent
    ],
    providers: [
        { provide: NgbDateAdapter, useClass: CustomDateAdapter },
        { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter },
        FormFunctions
    ]
})
export class SharedModule {

}